import { PixelRatio } from 'react-native';

import type { MenuPickerContext } from '../state/menu-picker';
import type { MenuItemCustomizationOption, MenuItemCustomizationOptionGroup } from '../types';

const BASE_MENU_URL = '/v2/menu';

export const getUrlForItemDetailPageFromSlug = (slug: string) => {
  return `${BASE_MENU_URL}/${slug}`;
};

export const formatCentsToDollars = (cents: number) => {
  // Always include decimal places
  return cents > 0 ? `$${(cents / 100).toFixed(2)}` : null;
};

export const formatCentsToDollarsWithPlusSign = (cents: number) => {
  return cents > 0 ? `+ ${formatCentsToDollars(cents)}` : null;
};

export const formatCaloriesOffsetText = (caloriesOffset?: number): string => {
  // We still want to display this information when calories are 0.
  return caloriesOffset !== null || caloriesOffset !== undefined ? `${caloriesOffset} Cal` : '';
};

const dpr = Math.max(PixelRatio.get(), 3).toString();

export function optimizeSanityImageUri(uri: string = '', imageHeight: number): string {
  const imageUri = new URL(uri);
  imageUri.searchParams.set('h', imageHeight.toString());
  imageUri.searchParams.set('dpr', dpr);
  imageUri.searchParams.set('fm', 'webp');

  return imageUri.toString();
}

export function forEachCustomizationOptionInPickerAspectOption(
  pickerAspectOption: MenuPickerContext['selectedPickerAspectOption'],
  cb: ({
    customizationOption,
    customizationOptionGroup,
  }: {
    customizationOption: MenuItemCustomizationOption;
    customizationOptionGroup: MenuItemCustomizationOptionGroup;
  }) => void
) {
  for (const customizationOptionGroup of pickerAspectOption?.item?.customizations?.displayGroups ??
    []) {
    for (const customizationOption of customizationOptionGroup?.options ?? []) {
      cb({ customizationOption, customizationOptionGroup });
    }
  }
}
